import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { MDBDataTable } from "mdbreact";
import toastr from "toastr";
import { Row, Col, Card, CardBody, Button, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { apiError } from "../../../store/actions";
import $ from "jquery";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  getLocalbody,
  getDate,
  getFirstday,
} from "../../../helpers/globalFunctions";
import accessToken from "../../../helpers/jwt-token-access/accessToken";
import axios from "axios";
import moment from "moment";
import "./driverCollection.scss";
const DriverCollection = (props) => {
  const [searchData, setSearchData] = useState({
    from_date: getFirstday(new Date()),
    to_date: getDate(new Date()),
  });
  const [currentLocalbody, setCurrectLocalbody] = useState(getLocalbody());
  const [staffOptions, setStaffOptions] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [details, setDetails] = useState([]);
  // const [selectedLocation, setSelectedLocation] = useState(null);
  // const [locationOptions, setLocationOptions] = useState([]);
  const [tableData, setTableData] = useState({});
  const [popupView, setPopupView] = useState(false);
  const [driverCollectionItemDetails, setDriverCollectionItemDetails] =
    useState([]);
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
  // const dispatch = useDispatch();

  useEffect(() => {
    handleTableData();
    fetch_all_staff(currentLocalbody);
  }, [currentLocalbody]);

  const handleClickOpenForm = (item) => {
    axios
      .get(`${API_URL}waste/driver_collection_view?drop_id=` + item._id, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item) => {
            item.driver_info &&
              item.driver_info.map((el) => {
                if (el?.lastName)
                  item.driverName = el.firstName + " " + el.lastName;
                else item.driverName = el.firstName;
              });
            if (item?.staff_lastname)
              item.staff =
                item.staff_firstname +
                " " +
                item.staff_lastname;
            else item.staff = item.staff_firstname;

            let dropItems = item.drop_items;
            dropItems &&
              dropItems.map((itm, index) => {
                itm.id = index + 1;
                if (itm.helper_drop_item_paid_status === 0) itm.status = "Paid";
                else itm.status = "Unpaid";
              });

            setDriverCollectionItemDetails(dropItems);
            setTableData(item);
            setPopupView(true);
          });
      });
  };
  function handleTableData(
    from_date = "",
    to_date = "",
    // location = "",
    staff_id = ""
  ) {
    var url =
      `${API_URL}waste/driver_collection?localbody_id=` + currentLocalbody;
      if (from_date === "" && to_date === "") {
        from_date = from_date ? from_date : getFirstday(new Date());
        to_date = to_date ? to_date : getDate(new Date());
        }
    url =
      url +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&location=" +
      "" +
      "&staff_id=" +
      staff_id;
    axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        let dataToBeExported = [];
        result &&
          result.map((item, index) => {
            let exportItem = {};
            item.id = index + 1;

            item.date = moment(item?.driver_pickup_date).format("DD-MM-YYYY");

            if (item?.driver_lastname)
              item.staff = item.driver_firstname + " " + item.driver_lastname;
            else item.staff = item.driver_firstname;

            item.action = (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i
                  className="fas fa-eye"
                  style={{
                    fontSize: "1em",
                    cursor: "pointer",
                    marginLeft: "0.5em",
                    marginRight: "0.5em",
                  }}
                  onClick={() => {
                    handleClickOpenForm(item);
                  }}
                ></i>
              </div>
            );
            //export data
            // exportItem.id = item.id;
            // exportItem.Date = item.date;
            // exportItem.Visited_Houses = item.visited_houses;
            // exportItem.Paid_Hosues = item.paid_houses;
            // exportItem.House_Amt = item.house_amt;
            // exportItem.Visited_Shops = item.visited_shops;
            // exportItem.Paid_Shops = item.paid_shops;
            // exportItem.Shop_Amt = item.shop_amt;
            // exportItem.Total = item.total_amt;
            // exportItem.Weight = item.total_weight;

            dataToBeExported.push(exportItem);
          });
        setDetails(result);
        // setDataToBeExported(dataToBeExported);
      });
  }
  const fetch_all_staff = (id) => {
    axios
      .get(`${API_URL}user/options?localbody_id=`+id, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        var staff_data =
          res.data.data &&
          res.data.data.map((el) => {
            if (el?.lastName) el.name = el.firstName + " " + el.lastName;
            else el.name = el.firstName;
            return {
              label: el.name,
              value: el._id,
            };
          });
        setStaffOptions([
          {
            options: staff_data,
          },
        ]);
      });
  };
  const reset = () => {
    setSearchData({
      from_date: getFirstday(new Date()),
      to_date: getDate(new Date()),
    });
    setSelectedStaff(null);
    handleTableData();
  };
  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Date",
        field: "date",
        sort: "asc",
        width: 400,
      },
      {
        label: "ID",
        field: "helper_drop_pickup_id",
        sort: "asc",
        width: 200,
      },
      {
        label: "Location",
        field: "helper_drop_location",
        sort: "asc",
        width: 200,
      },
      {
        label: "Total Bags",
        field: "helper_drop_total_bags",
        sort: "asc",
        width: 200,
      },
      {
        label: "Total Weight",
        field: "helper_drop_total_weight",
        sort: "asc",
        width: 200,
      },
      {
        label: "Staff",
        field: "staff",
        sort: "asc",
        width: 200,
      },
      {
        label: "Action",
        field: "action",
        sort: "asc",
        width: 200,
      },
    ],
    rows: details,
  };
  const driverItemDetails = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Item Name",
        field: "helper_drop_items_name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Bags",
        field: "helper_drop_items_bags",
        sort: "asc",
        width: 150,
      },
      {
        label: "Weight",
        field: "helper_drop_items_weight",
        sort: "asc",
        width: 150,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 150,
      },
    ],
    rows: driverCollectionItemDetails,
  };
  let handleDate = (e) => {
    var date1 = $("#from_date").val();
    var date2 = $("#to_date").val();

    // let location = searchData?.location ? searchData.location : "";
    let staff_id = searchData?.staff_id ? searchData.staff_id : "";
    let toDate = moment(date1);
    let fromDate = moment(date2);
    let result = fromDate.diff(toDate, "days");

    if (result + 1 <= 0) {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
        ["to_date"]: "",
      });
      date2 = "";
    } else {
      setSearchData({
        ...searchData,
        [e.target.name]: e.target.value,
      });
    }
    handleTableData(date1, date2, staff_id);
  };

  const handleSelectChange = (selected, name) => {
    // let staff_id = searchData?.staff_id ? searchData.staff_id : "";
    // let location = searchData?.location ? searchData.location : "";
    let date1 = searchData?.from_date ? searchData.from_date : "";
    let date2 = searchData?.to_date ? searchData.to_date : "";
    switch (name) {
      case "staff":
        setSelectedStaff(selected);
        setSearchData({
          ...searchData,
          ["staff_id"]: selected.value,
        });
        handleTableData(date1, date2, selected.value);
        break;
      default:
        break;
    }
  };
  return (
    <React.Fragment>
      <Modal
        show={popupView}
        toggle={() => setPopupView(!popupView)}
        size="lg"
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Driver collection Details </h5>
          <button
            type="button"
            onClick={() => {
              setPopupView(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <AvForm className="needs-validation" onValidSubmit={(e, v) => {}}>
          <div className="modal-body">
            <table
              id="product_available_day"
              className="table table-bordered dataTable"
            >
              <tr>
                <td style={{ padding: "10px" }}>Date :</td>
                <td>{tableData?.drop_date}</td>
                <td>Name :</td>
                <td style={{ textAlign: "left" }}>{tableData?.driverName}</td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Drop ID :</td>
                <td>{tableData?.helper_drop_id}</td>
                <td>Warehouse :</td>
                <td style={{ textAlign: "left" }}>
                  {tableData?.helper_drop_location}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Total Bags :</td>
                <td>{tableData?.helper_drop_total_bags}</td>
                <td>Total Weight :</td>
                <td style={{ textAlign: "left" }}>
                  {tableData?.helper_drop_total_weight}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Latitude :</td>
                <td>{tableData?.helper_drop_latitude}</td>
                <td>Longitude :</td>
                <td style={{ textAlign: "left" }}>
                  {tableData?.helper_drop_longitude}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px" }}>Staff :</td>
                <td>{tableData?.staff}</td>
                <td></td>
                <td style={{ textAlign: "left" }}>{}</td>
              </tr>
            </table>
            {driverCollectionItemDetails &&
            driverCollectionItemDetails.length > 0 ? (
              <Row className="mt-3 mb-2">
                <h6
                  className="modal-title mt-0"
                  style={{ textAlign: "center" }}
                >
                  Driver Collection Item Details
                </h6>
              </Row>
            ) : null}
            {driverCollectionItemDetails &&
            driverCollectionItemDetails.length > 0 ? (
              <Row>
                <MDBDataTable
                  id="driverDropItemDetailId"
                  responsive
                  bordered
                  data={driverItemDetails}
                  searching={false}
                  info={false}
                  paging={false}
                  disableRetreatAfterSorting={true}
                  //entries={10}
                />
              </Row>
            ) : null}
          </div>
        </AvForm>
      </Modal>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Driver Collection" />
          <Col className="col-12">
            <Card>
              <CardBody>
                <Row>
                  <Col md="2">
                    <div className="mb-3">
                      <Label htmlFor="validationCustom05">From</Label>
                      <input
                        className="form-control"
                        type="date"
                        id="from_date"
                        name="from_date"
                        value={searchData?.from_date}
                        onChange={handleDate}
                      />
                    </div>
                  </Col>
                  <Col md="2">
                    <div className="mb-3">
                      <Label htmlFor="validationCustom05">To</Label>
                      <input
                        className="form-control"
                        type="date"
                        id="to_date"
                        name="to_date"
                        value={searchData?.to_date}
                        min={searchData?.from_date}
                        onChange={handleDate}
                      />
                    </div>
                  </Col>
                  {/* <Col md="2">
                    <div className="mb-3">
                      <Label>Location</Label>
                      <Select
                        name="location"
                        value={selectedLocation}
                        onChange={(selected) => {
                          handleSelectChange(selected, "location");
                        }}
                        options={locationOptions}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col> */}
                  <Col md="2">
                    <div className="mb-3">
                      <Label>Staff</Label>
                      <Select
                        name="staff_id"
                        value={selectedStaff}
                        onChange={(selected) => {
                          handleSelectChange(selected, "staff");
                        }}
                        options={staffOptions}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col md="1" style={{ paddingTop: "4px" }}>
                    <div className="mt-4 mb-3">
                      <Button
                        color="danger"
                        type="reset"
                        onClick={() => reset()}
                      >
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
                <MDBDataTable
                  id="driverCollectionTableId"
                  responsive
                  striped
                  bordered
                  data={data}
                  info={true}
                  searching={true}
                  disableRetreatAfterSorting={true}
                  entries={20}
                />
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {};

export default withRouter(
  connect(mapStateToProps, { apiError })(DriverCollection)
);

// Users.propTypes = {
//   error: PropTypes.any,
//   users: PropTypes.array,
// };
